import { useMemo } from 'react';

import { getStartEndIsoDate } from '@/utils/getStartEndIsoDate';

const useCodePreview = (
  exportType: string,
  from?: Date | null,
  to?: Date | null,
  fromPeriodType?: string,
  fromPeriod?: string
) => {
  const requestFromValue = useMemo(() => {
    if (exportType === 'range' && fromPeriod && fromPeriodType) {
      return `${fromPeriod}${fromPeriodType}`;
    }
    if (exportType === 'dates' && from) {
      return getStartEndIsoDate(from, 'start');
    }
    return 'all';
  }, [exportType, from, fromPeriod, fromPeriodType]);

  const requestToValue = useMemo(() => {
    if (exportType === 'dates' && to) {
      return getStartEndIsoDate(to, 'end');
    }
    return '';
  }, [exportType, to]);

  return {
    createRequestFromValue: () => requestFromValue,
    createRequestToValue: () => requestToValue
  };
};

export default useCodePreview;
